module.exports = __webpack_public_path__ + "static/media/Screenshot .89cceeba.png";